<template>
  <div>
    <v-navigation-drawer
      :value="isOpen"
      absolute
      right
      width="600px"
      style="z-index: 6; position: fixed"
      :height="dialogHeight"
      touchless
      hide-overlay
      stateless
    >
      <v-card elevation="0" class="ma-7" style ="background-color: transparent;">
        <v-card-title class="text-h5" v-if="Object.keys(this.aisleRow).length !== 0">{{getTranslated('_editLctAisleRow')}}</v-card-title>
        <v-card-title class="text-h5" v-else>{{getTranslated('_addLctAisleRow')}}</v-card-title>
        <v-card-text>
          <v-form @submit.prevent="save" v-model="valid" ref="form" style="flex: 1 1 auto">
            <v-text-field v-model="aisleRowPosX" :rules="requiredRule" type="number" :label="getTranslated('_aisleRowPosX')" min="0" max="99999"></v-text-field>
            <v-text-field v-model="aisleRowPosY" :rules="requiredRule" type="number" :label="getTranslated('_aisleRowPosY')" min="0" max="99999"></v-text-field>
            <v-text-field v-model="aisleRowAngle" :rules="requiredRule" type="number" :label="getTranslated('_aisleRowAngle')" min="0" max="99999"></v-text-field>
            <v-text-field v-model="aisleRowRackStartIndex" :rules="requiredRule" type="number" :label="getTranslated('_aisleRowRackStartIndex')" min="0" max="99999"></v-text-field>
            <v-text-field v-model="aisleRowColumnStartIndex" :rules="requiredRule" type="number" :label="getTranslated('_aisleRowColumnStartIndex')" min="0" max="99999"></v-text-field>
            <v-text-field v-model="aisleRowColumnIncremental" :rules="requiredRule" type="number" :label="getTranslated('_aisleRowColumnIncremental')" min="0" max="99999"></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-tooltip top :disabled="valid" transition="slide-y-reverse-transition">
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-btn color="primary" text :disabled="!valid" :loading="loading" @click.stop="save">{{getTranslated('_save')}}</v-btn>
              </div>
            </template>
            <span>{{getTranslated('_saveRequiredValuesAlert')}}</span>
          </v-tooltip>
          <v-btn color="primary" text @click.stop="cancel">{{getTranslated('_cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-navigation-drawer>
    <v-overlay :value="isOpen" z-index="5">
    </v-overlay>
  </div>
</template>
<script>
import lctAisleRowService from '../services/Lct_AisleRowsService.js'

export default {
  name: 'Lct_AisleRowEditionDialog',
  props: {
    openDialog: {
      type: Boolean,
      default: false
    },
    isLeft: {
      type: Boolean,
      default: false
    },
    translations: Array,
    aisleRow: Object,
    aisleId: {
      type: String,
      default: null
    }
  },
  watch: {
    isOpen () {
      if (this.isOpen && Object.keys(this.aisleRow).length !== 0) {
        this.aisleRowPosX = this.aisleRow.aisleRowPosX.toString()
        this.aisleRowPosY = this.aisleRow.aisleRowPosY.toString()
        this.aisleRowAngle = this.aisleRow.aisleRowAngle.toString()
        this.aisleRowRackStartIndex = this.aisleRow.aisleRowRackStartIndex.toString()
        this.aisleRowColumnStartIndex = this.aisleRow.aisleRowColumnStartIndex.toString()
        this.aisleRowColumnIncremental = this.aisleRow.aisleRowColumnIncremental.toString()
        this.id = this.aisleRow.id
      }
    }
  },
  data () {
    return {
      title: '',
      valid: false,
      requiredRule: [v => !!v || this.getTranslated('_required')],
      dialogHeight: window.innerHeight,
      serversList: [],
      loading: false,
      aisleRowPosX: '1',
      aisleRowPosY: '1',
      aisleRowAngle: '1',
      aisleRowRackStartIndex: '',
      aisleRowColumnStartIndex: '',
      aisleRowColumnIncremental: '',
      id: ''
    }
  },
  computed: {
    isOpen: {
      get () {
        return this.openDialog
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    async save () {
      this.loading = true
      var aisleRowToUpdate = {
        aisleRowPosX: this.aisleRowPosX,
        aisleRowPosY: this.aisleRowPosY,
        aisleRowAngle: this.aisleRowAngle,
        aisleRowRackStartIndex: this.aisleRowRackStartIndex,
        aisleRowColumnStartIndex: this.aisleRowColumnStartIndex,
        aisleRowColumnIncremental: this.aisleRowColumnIncremental,
        id: this.id,
        aisleParent: this.aisleId,
        isLeft: this.isLeft
      }
      if (Object.keys(this.aisleRow).length !== 0) {
        await lctAisleRowService.updateLct_AisleRow(aisleRowToUpdate).then(res => {
          var notification = {
            color:
              res.request.status === 200 || res.request.status === 201
                ? 'green'
                : 'red',
            message:
              res.request.status === 200 || res.request.status === 201
                ? this.getTranslated('_LctAisleRowSaved')
                : this.getTranslated('_LctAisleRowSavedError')
          }
          this.loading = false
          this.$emit('saved', notification)
          this.cancel()
        })
      } else {
        await lctAisleRowService.createLct_AisleRow(aisleRowToUpdate).then(res => {
          var notification = {
            color:
              res.request.status === 200 || res.request.status === 201
                ? 'green'
                : 'red',
            message:
              res.request.status === 200 || res.request.status === 201
                ? this.getTranslated('_LctAisleRowSaved')
                : this.getTranslated('_LctAisleRowSavedError')
          }
          this.loading = false
          this.$emit('saved', notification)
          this.cancel()
        })
      }
    },
    cancel () {
      this.loading = false
      this.isOpen = false
      this.aisleRowPosX = '1'
      this.aisleRowPosY = '1'
      this.aisleRowAngle = '1'
      this.aisleRowRackStartIndex = ''
      this.aisleRowColumnStartIndex = ''
      this.aisleRowColumnIncremental = ''
      this.id = ''
    },
    getTranslated (key) {
      var translation = this.translations.filter(element => element.key === key)
      if (translation.length > 0) {
        return translation[0].translation
      } else {
        return 'Translation Error: ' + key
      }
    },
    handleResize (event) {
      this.dialogHeight = window.innerHeight
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
